import * as React from 'react';

export const TicketsIcon: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.625 5.25C9.55596 5.25 9.5 5.30596 9.5 5.375V6.625C9.5 6.69404 9.55596 6.75 9.625 6.75H9.875C9.94404 6.75 10 6.69404 10 6.625V5.375C10 5.30596 9.94404 5.25 9.875 5.25H9.625Z"
        fill="#3A3A3A"
      />
      <path
        d="M9.625 7.25C9.55596 7.25 9.5 7.30596 9.5 7.375V8.625C9.5 8.69404 9.55596 8.75 9.625 8.75H9.875C9.94404 8.75 10 8.69404 10 8.625V7.375C10 7.30596 9.94404 7.25 9.875 7.25H9.625Z"
        fill="#3A3A3A"
      />
      <path
        d="M9.5 9.375C9.5 9.30596 9.55596 9.25 9.625 9.25H9.875C9.94404 9.25 10 9.30596 10 9.375V10.625C10 10.694 9.94404 10.75 9.875 10.75H9.625C9.55596 10.75 9.5 10.694 9.5 10.625V9.375Z"
        fill="#3A3A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4.75C2 4.19772 2.44772 3.75 3 3.75H13C13.5523 3.75 14 4.19772 14 4.75V6.75C13.3096 6.75 12.75 7.30964 12.75 8C12.75 8.69036 13.3096 9.25 14 9.25V11.25C14 11.8023 13.5523 12.25 13 12.25H3C2.44772 12.25 2 11.8023 2 11.25V9.25C2.69036 9.25 3.25 8.69036 3.25 8C3.25 7.30964 2.69036 6.75 2 6.75V4.75ZM3 4.75H13V5.98388C12.2591 6.35206 11.75 7.11657 11.75 8C11.75 8.88343 12.2591 9.64794 13 10.0161V11.25H3L3 10.0161C3.74086 9.64794 4.25 8.88343 4.25 8C4.25 7.11657 3.74086 6.35206 3 5.98388L3 4.75Z"
        fill="#3A3A3A"
      />
    </svg>
  );
};
